<div class="page-sub-title">Edit Event</div>

<div class="wizard-step" *ngIf="currentStep === 'EVENTINFO'">
    <form #eventForm="ngForm" class="form">
        <div class="table-container">
            <table>
                <thead>
                    <tr><th>Golf Event Details</th></tr>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            <div class="field">
                                <input type="text" name="eventName" required [(ngModel)]="request.eventName" #eventNameModel="ngModel" placeholder=" " />
                                <label>Event Name</label>
                                <span class="error" *ngIf="eventNameModel.invalid && eventNameModel.touched">
                                    Event Name is required
                                </span>
                            </div>
                            <div class="field">
                                <textarea name="description" required [(ngModel)]="request.description" #descriptionModel="ngModel" placeholder=" "></textarea>
                                <label>Event Details</label>
                                <span class="error" *ngIf="descriptionModel.invalid && descriptionModel.touched">
                                    Details are required
                                </span>
                            </div>
                            <div class="field">
                                <input type="date" name="startDate" required [(ngModel)]="request.startDate" #startDateModel="ngModel" />
                                <label class="static">Event Start Date</label>
                                <span class="error" *ngIf="startDateModel.invalid && startDateModel.touched">
                                    Start Date is required
                                </span>
                            </div>
                            <div class="field">
                                <input type="date" name="endDate" required [(ngModel)]="request.endDate" #endDateModel="ngModel" />
                                <label class="static">Event End Date</label>
                                <span class="error" *ngIf="endDateModel.invalid && endDateModel.touched">
                                    End Date is required
                                </span>
                            </div>
                            <div class="field">
                                <input type="text" name="entryFee" required [(ngModel)]="request.entryFee" #entryFeeModel="ngModel" placeholder=" " />
                                <label>Entry Fee</label>
                                <span class="error" *ngIf="entryFeeModel.invalid && entryFeeModel.touched">
                                    Entry fee required
                                </span>
                            </div>
                            <div class="field">
                                <input type="text" name="firstPlacePrizeMoney" required [(ngModel)]="request.firstPlacePrizeMoney" placeholder=" " />
                                <label>1st Place Prize Money</label>
                            </div>
                            <div class="field">
                                <input type="text" name="secondPlacePrizeMoney" required [(ngModel)]="request.secondPlacePrizeMoney" placeholder=" " />
                                <label>2nd Place Prize Money</label>
                            </div>
                            <div class="field">
                                <input type="text" name="thirdPlacePrizeMoney" required [(ngModel)]="request.thirdPlacePrizeMoney" placeholder=" " />
                                <label>3rd Place Prize Money</label>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <button type="button" (click)="moveToStep('FORMAT')">Next: Scoring ></button>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <button type="button" (click)="cancel()" class="cancel">Cancel</button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </form>
</div>

<div class="wizard-step" *ngIf="currentStep === 'FORMAT'">
    <form #formatForm="ngForm" class="form">
        <div class="table-container">
            <table>
                <thead>
                    <tr><th>Scoring Details</th></tr>
                </thead>
                <tbody>
                    <tr>
                        <td colspan="2">
                            <p class="format-help">Leaderboards are always score to par (under/over par for counted rounds).</p>
                            <p class="format-help" *ngIf="isHybridScramble">
                                Hybrid Scramble scoring is fixed: individual standings, net scores with team handicaps,
                                and the best X net rounds per course are averaged before the course scores are added up.
                            </p>
                            <div class="field" *ngIf="!isHybridScramble">
                                <select name="scoreAggregation" required [(ngModel)]="request.scoreAggregation">
                                    <option value="SUM">Sum of best X scores</option>
                                    <option value="AVG">Average of best X scores</option>
                                </select>
                                <label>How Best Scores Combine</label>
                            </div>
                            <div class="checkbox-field" *ngIf="!isHybridScramble">
                                <input type="checkbox" name="isTeamEvent" [(ngModel)]="request.isTeamEvent" id="editIsTeamEvent" />
                                <label for="editIsTeamEvent">Is Team Event</label>
                            </div>
                            <div class="checkbox-field" *ngIf="!isHybridScramble">
                                <input type="checkbox" name="useHandicaps" [(ngModel)]="request.useHandicaps" id="editUseHandicaps" />
                                <label for="editUseHandicaps">Use Handicaps</label>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td><button type="button" (click)="moveToStep('EVENTINFO')">&lt; Back</button></td>
                        <td><button type="button" (click)="goToNextFromFormat()">{{ formatNextLabel }}</button></td>
                    </tr>
                    <tr>
                        <td colspan="2">
                            <button type="button" (click)="cancel()" class="cancel">Cancel</button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </form>
</div>

<div class="wizard-step" *ngIf="currentStep === 'COURSES'">
    <form #courseForm="ngForm" class="form">
        <div class="table-container" *ngFor="let slot of courseSlots; let i = index">
            <table>
                <thead>
                    <tr><th>{{ allowsMultipleCourses ? 'Course ' + (i + 1) : 'Course' }}</th></tr>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            <div class="field">
                                <input type="text" name="golfCourseName{{i}}" required [(ngModel)]="slot.golfCourseName" placeholder=" " />
                                <label>Golf Course Name</label>
                            </div>
                            <div class="field">
                                <input type="text" name="teeLocation{{i}}" required [(ngModel)]="slot.teeLocation" placeholder=" " />
                                <label>Tee Location</label>
                            </div>
                            <div class="field">
                                <input type="text" name="gimmeCircleSize{{i}}" required [(ngModel)]="slot.gimmeCircleSize" placeholder=" " />
                                <label>Gimme Circle Size</label>
                            </div>
                            <div class="field">
                                <select name="pinLocations{{i}}" required [(ngModel)]="slot.pinLocations">
                                    <option value="Thursday">Thursday</option>
                                    <option value="Friday">Friday</option>
                                    <option value="Saturday">Saturday</option>
                                    <option value="Sunday">Sunday</option>
                                </select>
                                <label>Pin Locations</label>
                            </div>
                            <div class="field">
                                <select name="holesToPlay{{i}}" required [(ngModel)]="slot.holesToPlay">
                                    <option value="FRONT9">Front 9</option>
                                    <option value="BACK9">Back 9</option>
                                    <option value="ALL18">All 18</option>
                                </select>
                                <label>Holes To Play</label>
                            </div>
                            <div class="field">
                                <input type="text" name="coursePar{{i}}" required [(ngModel)]="slot.coursePar" placeholder=" " />
                                <label>Course Par</label>
                            </div>
                            <div class="field">
                                <input type="number" name="roundsToCount{{i}}" required [(ngModel)]="slot.roundsToCount" placeholder=" " />
                                <label>Number of rounds to count</label>
                            </div>
                            <div class="field">
                                <input type="number" name="maxRoundsToPost{{i}}" required [(ngModel)]="slot.maxRoundsToPost" placeholder=" " />
                                <label>Max rounds a team/player can post</label>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="table-container">
            <table>
                <tbody>
                    <tr>
                        <td><button type="button" (click)="moveToStep('FORMAT')">&lt; Back</button></td>
                        <td><button type="button" (click)="save()">Save Event</button></td>
                    </tr>
                    <tr>
                        <td colspan="2">
                            <button type="button" (click)="cancel()" class="cancel">Cancel</button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </form>
</div>
